import get from "lodash/get";

export default {
  getAudios(context, params) {
    const queryString = new URLSearchParams(params).toString();
    if (params.offset === 0) {
      context.commit("resetAudios");
    }
    return new Promise((resolve, reject) => {
      window.axios
        .get(
          `/courses/resources?category=audios&ordering=-created_at&${queryString}`
        )
        .then(response => {
          context.commit("setAudios", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  },
  getPodcasts(context) {
    return new Promise((resolve, reject) => {
      window.axios
        .get("/courses/categoryresource?id=5&level=0")
        .then(response => {
          context.commit(
            "setPodcasts",
            get(response, "data.results[0].children", [])
          );
          resolve();
        })
        .catch(reject);
    });
  },
  getPodcastEpisodes(context, id) {
    return new Promise((resolve, reject) => {
      window.axios
        .get(`/courses/resources?category_resource=${id}&limit=1000`)
        .then(response => {
          context.commit("setPodcastEpisodes", response.data.results);
          resolve();
        })
        .catch(reject);
    });
  }
};
